import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const BASE_URL = 'https://api.codebondingworkforce.com/api';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (userId) => ({
        url: '/admin-portal/login',
        method: 'POST',
        body: { userId },
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;